import { render, staticRenderFns } from "./moderators-console.vue?vue&type=template&id=b09ab59e&scoped=true&"
import script from "./moderators-console.ts?vue&type=script&lang=ts&"
export * from "./moderators-console.ts?vue&type=script&lang=ts&"
import style0 from "./moderators-console.vue?vue&type=style&index=0&id=b09ab59e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09ab59e",
  null
  
)

export default component.exports